import React, { useEffect, useRef, useState } from "react";
import resolveProps from "../../../utils/resolveProps";
import Link from "../Link";
import Text from "../Text";
import { Props } from "./types";
import "./index.scss";
import footerLinksFn from "mondrian-vanilla/core/components/Footer/footerLinks";
//imports elements

const config = {
  types: [
    {
      title: "default",
      isDefault: true,
    },
    "enterprise",
  ],
  modifiers: [
    {
      title: "signature",
      isDefault: true,
    },
    "bottom",
  ],
};

export default function Footer(props: Props) {
  const {
    // children,
    enterprise,
    data = {},
    tag,
    secondary,
    onClickLibras,
    librasProps,
    bottom,
    ...rest
  } = props;

  const {
    socialTagLinks = "",
    social = [],
    imageSrc = "",
    imageAlt = "",
    imageProps = {},
  } = data;
  const CustomTag = tag || "footer";
  const CustomSocialTag = socialTagLinks || "a";

  const isSocial =
    social && Array.isArray(social) && social?.length ? true : false;

  const rootElement = useRef();

  const machineYear = new Date().getFullYear();

  const [currentYear, setCurrentYear] = useState(machineYear);

  useEffect(() => {
    const getYear = async () => {
      try {
        const response = await fetch('https://mondrian.claro.com.br/vanilla/mondrian-vanilla-latest.json');
        const data = await response.json();
        if (data && data.currentYear !== undefined) {
          setCurrentYear(data.currentYear);
        } else {
          console.error('Failed to retrieve current year from API');
        }
      } catch (error) {
        console.error('Error fetching current year:', error);
      }
    };

    getYear();
  }, []);

  useEffect(() => {
    rootElement.current && footerLinksFn(rootElement.current);
  }, [rootElement]);

  console.log(imageProps)

  return (
    <div ref={rootElement}>
      {data.linkList && (
        <div className={`${resolveProps(props, config, "FooterLinks")}`}>
          <div className="mdn-Container">
            <div className="mdn-Row">
              {data.linkList?.map((list, index) => {
                return (
                  <div
                    key={index}
                    className="mdn-Col-xs-12 mdn-Col-md-6 mdn-Col-lg-3 mdn-FooterLinks-column"
                  >
                    <p className="mdn-Text mdn-Text--body mdn-Text--inverse">
                      {list.title}
                    </p>
                    <button className="mdn-Text mdn-Text--body mdn-Text--inverse mdn-FooterLinks-column-toggler">
                      {list.title}
                      <i
                        aria-hidden="true"
                        className="mdn-Accordion-icon mdn-Icon-baixo"
                      ></i>
                    </button>
                    <ul className="mdn-LinkList mdn-LinkList--inverse">
                      {list.links.map((link, index) => {
                        return (
                          <li key={index} className="mdn-LinkList-item">
                            <a className="mdn-LinkList-anchor" href={link.href}>
                              {link.title}
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                    <hr className="mdn-Divider mdn-Divider--horizontal mdn-Divider--default" />
                  </div>
                );
              })}

              {data.etc && (
                <div className="mdn-Col-xs-12 mdn-Col-md-12 mdn-Col-lg-3 mdn-FooterLinks-column">
                  {data.etc}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <CustomTag
        {...rest}
        className={`${resolveProps(props, config, "Footer")} ${isSocial ? "mdn-Footer--social" : "mdn-Footer--simple"
          } ${bottom ? "mdn-Footer--signature" : ""}`}
        role="contentinfo"
      >
        <div className="mdn-Container">
          <div className="mdn-Footer-content">
            <div
              className={`mdn-Footer-${isSocial ? "social-and-" : ""
                }disclaimer`}
            >
              {isSocial && (
                <>
                  <ul className="mdn-Footer-list">
                    <li className="mdn-Footer-list-item mdn-Footer-list-item--text">
                      <Text body inverse>
                        Siga @clarobrasil
                      </Text>
                    </li>
                    {Array.isArray(social) &&
                      social?.map((item, index) => {
                        const {
                          href = "",
                          icon = "",
                          gtm = {},
                          ...itemRest
                        } = item;

                        const classIcon = item.icon
                          ? `mdn-Icon-${item?.icon}`
                          : "";

                        return (
                          <li
                            key={`social-icon-${index}`}
                            className="mdn-Footer-list-item"
                          >
                            {href ? (
                              <Link
                                tag={CustomSocialTag}
                                href={href}
                                gtm={gtm}
                                {...itemRest}
                                target="_blank"
                              >
                                {!!item?.children ? (
                                  item?.children
                                ) : (
                                  <span
                                    aria-hidden="true"
                                    className={`${classIcon} mdn-Icon--md`}
                                  />
                                )}
                              </Link>
                            ) : (
                              <>
                                {!!item?.children ? (
                                  item?.children
                                ) : (
                                  <span
                                    {...itemRest}
                                    aria-hidden="true"
                                    className={`${classIcon} mdn-Icon--md mdn-Text--inverse`}
                                  ></span>
                                )}
                              </>
                            )}
                          </li>
                        );
                      })}
                  </ul>
                </>
              )}
              <div className="mdn-Footer-disclaimer">
                <p className="mdn-Text mdn-Text--caption mdn-Text--inverse">
                  {data.privacy?.map((item, index) =>
                    !!item?.children ? (
                      item?.children
                    ) : (
                      <a
                        className="mdn-Footer-disclaimer-link"
                        href={item.href}
                        target={item.target}
                        key={index}
                      >
                        {item.text}
                      </a>
                    )
                  )}
                  {data.privacy &&
                    (onClickLibras || librasProps?.onClickLibras) && (
                      <button
                        className={`mdn-Footer-disclaimer-librasLink ${librasProps?.gtm?.gtmClassName || ""
                          }`}
                        onClick={librasProps?.onClickLibras || onClickLibras}
                        {...librasProps?.buttonProps}
                        {...librasProps?.gtm?.dataGTM}
                      >
                        <i
                          className="mdn-Icon-libras mdn-Icon--sm"
                          style={{
                            color: "var(--color-neutral-lightest)",
                            cursor: "pointer",
                          }}
                        ></i>
                      </button>
                    )}
                </p>
                <p className="mdn-Text mdn-Text--caption mdn-Text--inverse">
                  <strong>
                    © {currentYear} Claro. Todos os direitos reservados <br />
                    <span className="mdn-Text-dash">- </span>CNPJ:
                    40.432.544/0001-47 <br />
                    <span className="mdn-Text-dash">- </span>Rua Henri Dunant, 780 -
                    São Paulo - SP
                  </strong>
                </p>
              </div>
            </div>
            <div
              className={`mdn-Footer-logo ${data.imageSrc ? "mdn-Footer-logo--custom" : ""
                }`}
            >
              <img
                className="mdn-Footer-logo-image"
                src={
                  imageSrc ||
                  "https://mondrian.claro.com.br/brands/nosvg/assinatura-claro.png"
                }
                alt={imageAlt || "Logo da Claro"}
                {...imageProps}
              />
            </div>
          </div>
        </div>
      </CustomTag>
    </div>
  );
}
